import { useCallback, useEffect, useState } from "react"

import { Modal, Skeleton, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"

import FaqAccordion from "../../../../Components/FaqAccordion"
import { RECEIPT_FAQ } from "../../api/receiptFaqMock"
import { getReceiptFaqThunk } from "../../redux/receipt.thunks"

import styles from "./FaqStub.module.less"

const { Text } = Typography

export const FaqStub = ({ isMobile, open, onClose }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(false)

  const fetchFaq = useCallback(
    async (controller) => {
      setLoading(true)
      try {
        const data = await dispatch(getReceiptFaqThunk()).unwrap()
        if (!controller.cancelled) setItems(data)
      } catch {
        // todo: remove this later when the query is ready
        setItems(RECEIPT_FAQ)
        // global error notification is already dispatched from the thunk
      } finally {
        if (!controller.cancelled) setLoading(false)
      }
    },
    [dispatch]
  )

  useEffect(() => {
    if (!open) return
    const controller = { cancelled: false }
    void fetchFaq(controller)
    return () => {
      controller.cancelled = true
    }
  }, [open, fetchFaq])

  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      title={t("FAQs")}
      width={640}
      centered={!isMobile}
      destroyOnHidden
      data-testid="faq-stub-modal"
    >
      <Text type="secondary" data-testid="faq-stub-description">
        {t(
          "Learn how Digital Receipt helps customers recognize purchases and reduce avoidable disputes."
        )}
      </Text>
      <div className={styles.accordionWrap} data-testid="faq-stub-accordion-wrap">
        {loading ? (
          <Skeleton active paragraph={{ rows: 10 }} data-testid="faq-stub-loading-skeleton" />
        ) : (
          <FaqAccordion items={items} />
        )}
      </div>
    </Modal>
  )
}
